import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}), []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (!data.must_change_password) loadSettings();
    } catch {
      setUser(false);
    }
  }, [loadSettings]);

  useEffect(() => {
    refresh();
    const out = () => setUser(false);
    window.addEventListener("kabch-logout", out);
    return () => window.removeEventListener("kabch-logout", out);
  }, [refresh]);

  const setSession = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
    if (!u.must_change_password) loadSettings();
  };

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setSession(data.token, data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  const can = (...perms) => !!user && perms.some((p) => user.effective_permissions?.includes(p));

  return (
    <AuthCtx.Provider value={{ user, settings, loadSettings, login, logout, setSession, can, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function homePath(u) {
  const p = u?.effective_permissions || [];
  if (p.includes("view_dashboard")) return "/dashboard";
  if (p.includes("create_sale")) return "/sales/new";
  if (p.includes("view_sales")) return "/sales";
  if (p.includes("record_selection")) return "/pen";
  if (p.includes("confirm_exit")) return "/gate";
  if (p.includes("confirm_delivery") || p.includes("view_my_sections")) return "/barn";
  if (p.includes("verify_permit")) return "/gate";
  return "/no-access";
}
